module.exports = __webpack_public_path__ + "static/img/bcg_k2.467d9434.png";